import styled from "@rentiohq/web-theme";

export const OfficeRole = styled.div``;

export const RoleText = styled.p`
  color: ${props => props.theme.colors.grey};
`;
